import RiskSelector from "./RiskSelectorContainer";
export default RiskSelector;



// WEBPACK FOOTER //
// ./src/workerhome/components/Content/RiskSelector/index.js